import React, { useEffect, useState } from 'react';
import { ServerUrlContext } from './ServerUrlContext';
import { getConfig } from '../helpers/configHelper';

export const ServerUrlProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [serverUrl, setServerUrl] = useState<string>(''); // Update the type to string

    useEffect(() => {
        const initServerUrl = async () => {
            try {

                // // 1) Intentar desde localStorage
                // const stored = localStorage.getItem('server_url');
                // if (stored) {
                //     setServerUrl(stored);
                //     return;
                // }

                // 2) Cargar desde config.json vía helper (con cache y fallback)
                const config = await getConfig();
                if (config?.SERVER_URL) {
                    console.log(`ServerUrlProvider: serverUrl: ${config.SERVER_URL}`);
                    
                    // Manejo especial para entorno 'local'
                    if (config.SERVER_URL === 'local') {
                        const localUrl = navigator.userAgent.toLowerCase().includes('android') 
                            ? 'http://10.0.2.2:8001' 
                            : 'http://127.0.0.1:8001';
                        setServerUrl(localUrl);
                        localStorage.setItem('server_url', localUrl);
                    } else {
                        setServerUrl(config.SERVER_URL);
                        // Persistir para siguientes cargas
                        localStorage.setItem('server_url', config.SERVER_URL);
                    }
                }
            } catch (err) {
                console.error('Error inicializando ServerUrlProvider:', err);
            }
        };

        initServerUrl();
    }, []);

    return (
        <ServerUrlContext.Provider value={serverUrl}>
            {children}
        </ServerUrlContext.Provider>
    );
};